import { catalog } from "./data/catalog.js";
import createShareContainer from './modules/create-share-container.js';
import Filter from "./modules/filter.js";

const word = `son`;
// console.log(word);
const keys = Object.values(catalog[`deer`]);
// console.log(keys);
const divsWithCertainClassName = keys.filter(
  (it) => {
    // console.log(it.filter);
    let a = it.filter.indexOf(word);
    // console.log(a);

    return it.filter.indexOf(word) >= 0;
  }
);
// console.log(divsWithCertainClassName);


const siteBodyElement = document.querySelector(`.page__body`);

const filter = new Filter(siteBodyElement);
filter.init();


// const shareContainerPopup = createShareContainer();
// shareContainerPopup.classList.add('congrats__share');
// shareContainerPopup.classList.add('share__list_present');
// shareContainerPopup.classList.add('share__list');
const shareContainerFooter = createShareContainer();
shareContainerFooter.classList.add('share__list');
// document.querySelector('.congrats__wrap').append(shareContainerPopup);
document.querySelector('.page__footer').append(shareContainerFooter);
// const  wheelFortune = new WheelFortune(siteBodyElement);
// wheelFortune.init();
